import { Recipient } from './Recipient';

export class Cart {
    public productTypeId: string;
    public productId: string;
    public comment: string;
    public zoneType: string;
    public zoneFrom: string;
    public zoneTo: string;
    public friendlyCombination: string;
    public recipients: Recipient[];
    public invoiceReference: string;
    public sendDate: string;
    public endDate: string;
    public recurring: boolean;
    public interval: string;
    public departmentId: string;
    public organizationDepartmentEmployeeCount: number;
    public productTypeTicketMaxCount: number;

    constructor() {
        this.productTypeId = '';
        this.recipients = new Array<Recipient>();
    }
}
